import { _ } from "i18n";
import { DataSourceOption } from "./types";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import clsx from "clsx";
import "./TeamGroupSelector.scss";
import { NetworkSelect } from "./NetworkSelect";

export function TeamGroupSelector({
	enabled,
	options,
	selected,
	onToggle,
	onSelect,
	logoBasePath,
	disabled = false,
}: {
	enabled: boolean,
	options: DataSourceOption[],
	selected: string[],
	onToggle: (enabled: boolean) => void;
	onSelect: (values: string[]) => void;
	logoBasePath?: string;
	disabled?: boolean;
}) {
	if (options.length === 0) {
		return null;
	}

	return (
		<div>
			<div
				className={clsx("networks-banner", disabled && "networks-banner--disabled")}
				onClick={() => !disabled && onToggle(!enabled)}
				aria-disabled={disabled}
			>
				<div className={`networks-banner__inner ${enabled ? 'is-active' : ''}`}>
					<div className="networks-banner__content">
						<strong>{_("country.selection.network.title")}</strong><br />
						{_("country.selection.network.subtitle")}
					</div>
					<div className="networks-banner__toggle">
						<ToggleSwitch
							handleChange={() => onToggle(!enabled)}
							selected={enabled}
							disabled={disabled}
						/>
					</div>
				</div>
			</div>
		{enabled && (
			<div className="networks-select">
				<label className="networks-select__label">{_("country.selection.network.selectLabel")}</label>
				<NetworkSelect
					placeholder={_("label.select")}
					options={options}
					value={selected}
					onChange={onSelect}
					logoBasePath={logoBasePath}
				/>
			</div>
		)}
		</div>
	);
}
